import { Module } from 'vuex';

import { ShiftCMSState } from '@/store';
import { Goal } from '@/models/goal.model';
import { EventSource } from '@/models/event-source.model';
import goalsService from '@/services/goals.service';

export interface GoalsState {
  items: Goal[];
  goalsTotal: number;
  sources: EventSource[];
}

export enum GoalsMutations {
  SetGoals = 'go/SetGoals',
  SetGoalsTotal = 'go/SetGoalsTotal',
}

export enum GoalsActions {
  GetGoal = 'go/GetGoal',
  GetGoals = 'go/GetGoals',
  AddGoal = 'go/AddGoal',
  UpdateGoal = 'go/UpdateGoal',
  UpdateGoalsOrderItems = 'go/UpdateGoalsOrderItems',
  DeleteGoal = 'go/DeleteGoal',
  PublishGoal = 'go/PublishGoal',
}

const sn = (str: GoalsActions | GoalsMutations): string =>
  str.replace(/go\//g, '');

export const goalsStore: Module<GoalsState, ShiftCMSState> = {
  namespaced: true,
  state: {
    items: [],
    goalsTotal: 0,
    sources: [],
  },
  mutations: {
    [sn(GoalsMutations.SetGoals)](state, items: Goal[]) {
      state.items = items;
    },
    [sn(GoalsMutations.SetGoalsTotal)](state, total: number) {
      state.goalsTotal = total;
    },
  },
  actions: {
    async [sn(GoalsActions.GetGoal)](_, id) {
      const res = await goalsService.get(id);
      if (res.status) {
        return res.data;
      }
    },
    async [sn(GoalsActions.GetGoals)]({ commit }) {
      const res = await goalsService.getList();
      if (res.status) {
        commit(sn(GoalsMutations.SetGoals), res.data.items);
        commit(sn(GoalsMutations.SetGoalsTotal), res.data.total);
      }
    },
    async [sn(GoalsActions.AddGoal)]({ dispatch }, item: Goal) {
      const res = await goalsService.create(item);
      if (res.status) {
        dispatch(sn(GoalsActions.GetGoals));
      }

      return res.status;
    },
    async [sn(GoalsActions.UpdateGoal)]({ dispatch }, item: Goal) {
      const res = await goalsService.update(item);
      if (res.status) {
        dispatch(sn(GoalsActions.GetGoals));
      }
      return res.status;
    },
    async [sn(GoalsActions.PublishGoal)]({ dispatch }, item: Goal) {
      const res = await goalsService.publish(item.id, item.published);
      if (res.status) {
        dispatch(sn(GoalsActions.GetGoals));
      }
      return res.status;
    },
    async [sn(GoalsActions.DeleteGoal)]({ dispatch }, id: number) {
      const res = await goalsService.delete(id);

      if (res.status) {
        dispatch(sn(GoalsActions.GetGoals));
      }
    },
  },
};
